/**
 * @generated SignedSource<<3e22fccae2dd071e44f7f857a55202a7>>
 * @relayHash da733dd711e8de9cafbe0491586c07de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e510066e0ee04ed0000c02a643b8112ba7e700b1ff47c67a7fd623019609fe1e

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MoreProjectsQuery$variables = {
  cloudId: string;
  currentURL?: AGG$URL | null | undefined;
  isProjectsSearchInSidebarEnabled: boolean;
};
export type MoreProjectsQuery$data = {
  readonly jira: {
    readonly canBrowseProjects: {
      readonly hasPermission: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly jira_projectsSidebarMenu: {
    readonly moreFavourites: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"ProjectSection_projectNode">;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly moreRecents: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"ProjectSection_projectNode">;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly otherItems?: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"ProjectSection_projectNode">;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type MoreProjectsQuery = {
  response: MoreProjectsQuery$data;
  variables: MoreProjectsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currentURL"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isProjectsSearchInSidebarEnabled"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "alias": "canBrowseProjects",
      "args": [
        (v1/*: any*/),
        {
          "kind": "Literal",
          "name": "type",
          "value": "BROWSE_PROJECTS"
        }
      ],
      "concreteType": "JiraPermission",
      "kind": "LinkedField",
      "name": "permission",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "hasPermission"
        }
      ]
    }
  ]
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "currentURL",
    "variableName": "currentURL"
  }
],
v4 = [
  {
    "concreteType": "JiraProjectEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ProjectSection_projectNode"
      }
    ]
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = [
  {
    "concreteType": "JiraProjectEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "large"
              }
            ]
          },
          {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "url"
                  }
                ],
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "MoreProjectsQuery",
    "selections": [
      (v2/*: any*/),
      {
        "args": (v3/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_projectsSidebarMenu",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreFavourites",
            "plural": false,
            "selections": (v4/*: any*/)
          },
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreRecents",
            "plural": false,
            "selections": (v4/*: any*/)
          },
          {
            "condition": "isProjectsSearchInSidebarEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraProjectConnection",
                "kind": "LinkedField",
                "name": "otherItems",
                "plural": false,
                "selections": (v4/*: any*/)
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MoreProjectsQuery",
    "selections": [
      (v2/*: any*/),
      {
        "args": (v3/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_projectsSidebarMenu",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreFavourites",
            "plural": false,
            "selections": (v6/*: any*/)
          },
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreRecents",
            "plural": false,
            "selections": (v6/*: any*/)
          },
          {
            "condition": "isProjectsSearchInSidebarEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraProjectConnection",
                "kind": "LinkedField",
                "name": "otherItems",
                "plural": false,
                "selections": (v6/*: any*/)
              }
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "e510066e0ee04ed0000c02a643b8112ba7e700b1ff47c67a7fd623019609fe1e",
    "metadata": {},
    "name": "MoreProjectsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2706305e7b01e5ae823b2256bf00da6b";

export default node;
